import React, { useState } from "react";
import { AlertTriangle, Phone, X } from "lucide-react";

const FraudNotificationStrip = ({ isSecondary }) => {
  const [open, setOpen] = useState(true);

  const theme = isSecondary ? {
    bg: "#eff6ff", // blue-50
    border: "#dbeafe", // blue-100
    accentBg: "#dbeafe", // blue-100
    iconColor: "#2563eb", // blue-600
    labelColor: "#1d4ed8", // blue-700
    phoneColor: "#1e40af", // blue-800
    dismissHover: "#dbeafe"
  } : {
    bg: "#fff1f2", // rose-50
    border: "#ffe4e6", // rose-100
    accentBg: "#ffe4e6", // rose-100
    iconColor: "#e11d48", // rose-600
    labelColor: "#be123c", // rose-700
    phoneColor: "#9f1239", // rose-800
    dismissHover: "#ffe4e6"
  };

  if (!open) return null;

  return (
    <div
      className="fraud-notification-strip"
      style={{
        width: "100%",
        background: theme.bg,
        color: "#334155", // slate-700
        position: "relative",
        zIndex: 1300,
        fontFamily: "'Inter', 'Poppins', sans-serif",
        borderBottom: `1px solid ${theme.border}`,
      }}
    >
      <div
        className="fraud-strip-container"
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "8px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <div className="fraud-content-left" style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
          <div style={{
            background: theme.accentBg,
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}>
            <AlertTriangle size={16} strokeWidth={2.5} color={theme.iconColor} />
          </div>
          
          <div style={{ display: "flex", flexDirection: "row", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ fontWeight: 600, fontSize: "0.85rem", color: theme.labelColor }}>
              Security Alert:
            </span>
            <span style={{ fontSize: "0.85rem", lineHeight: 1.4 }}>
              Ignore fraudulent payment requests on WhatsApp or unofficial sources. Only trust emails ending with <strong style={{ color: "#1e293b", fontWeight: 600 }}>@accredian.com</strong>.
            </span>
          </div>
        </div>

        <div className="fraud-strip-actions" style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
          <div
            style={{
              background: theme.accentBg,
              borderRadius: "100px",
              padding: "4px 12px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Phone size={14} color={theme.iconColor} />
            <span className="helpline-label" style={{ fontWeight: 500, fontSize: "0.8rem", whiteSpace: "nowrap", color: theme.labelColor }}>
              Student Helpline:
            </span>
            <a
              href="tel:+917969547220"
              style={{
                color: theme.phoneColor,
                fontWeight: 600,
                textDecoration: "none",
                fontSize: "0.85rem",
                whiteSpace: "nowrap",
              }}
              onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
              onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
            >
              07969547220
            </a>
          </div>
          
          <button
            onClick={() => setOpen(false)}
            style={{
              background: "transparent",
              border: "none",
              color: "#64748b",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              transition: "all 0.2s",
            }}
            onMouseOver={(e) => { e.currentTarget.style.background = theme.dismissHover; e.currentTarget.style.color = theme.iconColor; }}
            onMouseOut={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#64748b"; }}
          >
            <X size={18} />
          </button>
        </div>
      </div>
      
      <style>
        {`
          @media (max-width: 768px) {
            .fraud-strip-container {
              flex-direction: column !important;
              align-items: flex-start !important;
              padding: 12px 20px !important;
              gap: 12px !important;
            }
            .fraud-content-left {
              align-items: flex-start !important;
            }
            .fraud-strip-actions {
              width: 100%;
              justify-content: space-between !important;
              padding-left: 42px; /* Align with text */
            }
            .helpline-label {
              display: none; /* hide text on very small screens to save space */
            }
          }
        `}
      </style>
    </div>
  );
};

export default FraudNotificationStrip;

